import React from 'react';
import { Link } from 'react-router-dom';
import logoIconSvg from 'components/Dashboard/logo-icon-dark.svg';
import logoTextSvg from 'components/Brand/TextLogo/logo.svg';
import './SignUpLayout.scss';

interface Props {
  title: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export default function SignUpLayout({ title, footer, children }: Props) {
  return (
    <main className="SignUpLayout">
      <div className="SignUpLayout-main">
        <Link to="/" className="SignUpLayout-brand">
          <img className="SignUpLayout-brand__icon" src={logoIconSvg} alt="" />
          <img className="SignUpLayout-brand__text" src={logoTextSvg} alt="The Host Co" />
        </Link>
        <div className="SignUpLayout-content">
          <h1 className="SignUpLayout-content__title">{title}</h1>
          {children}
        </div>
        {footer}
      </div>
      <aside className="SignUpLayout-photo" />
    </main>
  );
}
